import React, { useState, useContext } from "react";
import UserServiceApi from "../../Services/UserService";
import "../../forms-style.scss";
import { createCookie, getServiceCodeForgotPwd, getPortalCD, getTenantId, setIPConfig } from "../../Util/helper";
import ButtonComponent from "../../Components/Shared/ButtonComponent";
import AuthServiceApi from "../../Services/AuthService";
import DocBuilderService from "../../Services/DocBuilderService";
import { readCookie } from "../../Util/helper";
import { validateSignupEmail } from "../../Validators/GenericValidator";
import UserDataContext from "../../Contexts/User.context";
import { UserActionEnum } from "../../Config/UserType";
import InputType from "../../Components/Shared/InputType";
import { getTenantGroupId } from "../../Util/general-config";

type Props = {};

const ForgetPassword = (props: Props) => {
  const [emailId, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [disableBtn, setdisableBtn] = useState(false);
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [responseError, setResponseError] = useState("");

  const onEmailChangeHandler = (e: { target: { value: any } }) => {
    const {
      target: { value },
    } = e;
    setEmail(value);
  };

  const validateData = () => {
    setEmailError(false);

    let errors = 0;

    const emailValidator = validateSignupEmail(emailId.trim());
    if (emailValidator.isValid === false) {
      ++errors;
      setEmailError(true);
      if (emailId.trim() === "") {
        setEmailErrorMsg("Email can't be blank");
      } else {
        setEmailErrorMsg("What is this?! Please provide a valid email address.");
      }
    }

    if (errors > 0) {
      ++errors;
      setdisableBtn(false);
      return false;
    } else {
      setdisableBtn(true);
      return true;
    }
  };
  const { state, dispatch } = useContext(UserDataContext);

  const onForgotPass = () => {
    const isValid = validateData();
    if (isValid) {
      const params = {
        serviceCode: getServiceCodeForgotPwd(),
        email: emailId.trim(),
        tenantId: getTenantId(),
        locale: "en",
        tenantGroupId: getTenantGroupId(),
      };
      const forgotPassResponse = UserServiceApi.forgotPassword(params)
        .then((userResponse: any) => {
          if (userResponse) {
            console.log("inside forgotPassword");
            setResponseError("A temporary password has been sent to your email address. Please check your email.");
            //dispatch(savePersonalInfoSuccess(response.data.docGuid));
          } else {
            //dispatch(savePersonalInfoFailure(response.data));
          }
          return userResponse;
        })
        .catch((error) => {
          console.log("Error");
          setResponseError("That's embarrassing! This user does not exist.");
          return error.response.statusText;
        });
      console.log("params", params);
    }
  };
  return (
    <>
      <section className="signup_section forgot-password">
        <div className="container">
          <div className="signup_inner">
            <h1>Forgot Password</h1>
            <p className="form-signin-heading text-center">Please Provide your email address</p>
            <div className="alert-danger ">
              <div className="form-text">
                {emailError && (
                  <p style={{ color: "red" }} key="pswrdErr" className="alert error signup-error-message">
                    {/* <span>error prohibited this user from being saved:</span>
                                        <br /> */}
                    {emailError && emailErrorMsg}
                  </p>
                )}
              </div>
            </div>

            {responseError && (
              <small className="text-danger" style={{ fontSize: 12 }}>
                {responseError}
              </small>
            )}
            <div className="input_area">
              <div className="form-group mb-2">
                <InputType
                  inputProps={{
                    id: "emailTextBox",
                    text: "Email",
                    type: "email",
                    className: "form-control input-lg email",
                    index: 0,
                    name: "email",
                    placeholder: "Email",
                    value: emailId.trim() || "",
                  }}
                  changeHandler={onEmailChangeHandler}
                />
                <p>
                  <small>We will send a temporary password with user ID to this email</small>
                </p>
              </div>
              <div className="fbn bounce-effect">
                <ButtonComponent
                  buttonProps={{
                    disabled: disableBtn,
                    className: "theme_btn alante",
                    text: "SEND TEMPORARY PASSWORD",
                    id: "registerBtn",
                  }}
                  clickHandler={onForgotPass}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default ForgetPassword;
